"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sovizzo": {
    "9c93c16b": [{
      "hkey": "863da747",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "skipSearch": false
    }],
    "sovizzo-colle": [{
      "hkey": "863da747",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2df24dca": [{
      "hkey": "c2dd0078",
      "slug": "monte-san-lorenzo",
      "name": "Monte San Lorenzo",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;